define(["require", "exports", "tslib", "@material-ui/core/Checkbox", "@material-ui/core/FormControlLabel", "mobx-react", "react", "../../utils/EntityUtil", "./index", "./Tooltip"], function (require, exports, tslib_1, Checkbox_1, FormControlLabel_1, mobx_react_1, React, EntityUtil_1, index_1, Tooltip_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.CheckBoxField = void 0;
    Checkbox_1 = tslib_1.__importDefault(Checkbox_1);
    FormControlLabel_1 = tslib_1.__importDefault(FormControlLabel_1);
    React = tslib_1.__importStar(React);
    let CheckBoxField = exports.CheckBoxField = class CheckBoxField extends React.Component {
        constructor(props) {
            super(props);
            Object.defineProperty(this, "id", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "isRequired", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "tooltip", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            this.id = (0, EntityUtil_1.id)().toString();
            this.isRequired = props.propertyOwner.constructor[props.propertyName + "Req"] || false;
            this.tooltip = props.tooltip || (props.propertyOwner.constructor[props.propertyName + "Tooltip"] || "");
        }
        handleChange(value) {
            const { propertyOwner, propertyName, onChange, isBoolean } = this.props;
            const oldVal = propertyOwner[propertyName];
            const newVal = isBoolean ? (value ? 1 : 0) : value;
            if (onChange) {
                onChange(propertyOwner, propertyName, oldVal, newVal);
            }
            else {
                propertyOwner[propertyName] = newVal;
            }
        }
        render() {
            var _a;
            const { id, propertyOwner, propertyName, disabled, isBoolean, hideLabel, tooltipPlacement } = this.props;
            const value = propertyOwner[propertyName];
            const error = propertyOwner[propertyName + "Error"];
            const useTooltip = this.tooltip && this.tooltip.length > 50;
            const labelText = React.createElement("div", { style: { overflowWrap: "break-word", wordBreak: "break-all" } }, this.props.label);
            const label = error || useTooltip
                ? React.createElement(index_1.HGroup, { style: { flexGrow: 1 } },
                    React.createElement(index_1.VGroup, { style: { flexGrow: 1 } },
                        labelText,
                        error && React.createElement("div", { className: "field-error-label" }, error)),
                    useTooltip && tooltipPlacement != "left"
                        ? React.createElement(Tooltip_1.Tooltip, { text: this.tooltip, style: { alignItems: "flex-start" } })
                        : null)
                : labelText;
            const field = React.createElement(index_1.VGroup, { style: { justifyContent: "center" } },
                React.createElement(FormControlLabel_1.default, { control: React.createElement(Checkbox_1.default, { key: this.id, id: this.id, className: "field-checkbox", disabled: disabled, checked: (_a = (isBoolean ? value === 1 : value)) !== null && _a !== void 0 ? _a : false, onChange: e => this.handleChange.call(this, e.target.checked), style: { width: "auto", marginRight: "2px" } }), label: label || "", labelPlacement: "end" }),
                this.isRequired && (value == undefined || value == null)
                    ? React.createElement("div", { className: "warn" }, "\u00A0")
                    : null);
            if (!hideLabel) {
                return React.createElement(index_1.HGroup, { className: "form-field" },
                    useTooltip && tooltipPlacement == "left"
                        ? React.createElement("div", null,
                            React.createElement("span", { className: "label" }, id),
                            React.createElement(Tooltip_1.Tooltip, { text: this.tooltip, style: { alignItems: "flex-start" } }))
                        : React.createElement("span", { className: "label" }, id),
                    field);
            }
            else {
                return field;
            }
        }
    };
    exports.CheckBoxField = CheckBoxField = tslib_1.__decorate([
        mobx_react_1.observer
    ], CheckBoxField);
});
